import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import { COLOR_CODE, WEIGHT_CODES } from "theme/components/Variants/constants.js";
import VariantLayout from "./VariantLayout";

const ProductVariants = ({ variants, layout, ...props }) => {
    const variantColors = useSelector(
        ({ application }) => application.config.globalOptions?.product_page?.variant_colors,
    );
    const { t } = useTranslation();
    const currentSelectedParametrics = (selectedParametrics, variantId, parametricValue) => {
        return JSON.parse(JSON.stringify(selectedParametrics)).map((parametric) => {
            if (parametric.id === variantId) {
                parametric["value"] = parametricValue;
            }

            return parametric;
        });
    };

    variants = variants.map((variant, index) => {
        const { values, code } = variant;
        variant.isWeight = WEIGHT_CODES.indexOf(code) !== -1;
        variant.selectedValue = (props.selectedParametrics[index] || {}).value;

        if (variant.isWeight) {
            variant.name = t("pdp.size");
        }

        return {
            ...variant,
            values: values.reduce((result, val) => {
                if (!val.value) {
                    return result;
                }

                const { id } = val;

                if (code === COLOR_CODE) {
                    const variantColor = (variantColors || []).find((image) => image.color.id === id);
                    if (variantColor) {
                        val.image = variantColor?.image;
                        val.hexColor = variantColor.hex_code;
                    }
                }
                if (result.every((r) => r.value !== val.value)) {
                    result.push(val);
                }

                return result;
            }, []),
            index,
        };
    });

    return (
        <VariantLayout
            {...props}
            currentSelectedParametrics={currentSelectedParametrics}
            layout={layout}
            variants={variants}
        />
    );
};

ProductVariants.propTypes = {
    layout: PropTypes.string.isRequired,
    selectedParametrics: PropTypes.array.isRequired,
    variants: PropTypes.array.isRequired,
};

export default ProductVariants;
